<script>
import NextInput from 'dashboard/components-next/input/Input.vue';
import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

export default {
  components: {
    NextInput,
    RadioCard,
    Icon,
  },
  inject: ['v$'],
  props: {
    macroName: {
      type: String,
      default: '',
    },
    macroVisibility: {
      type: String,
      default: 'global',
    },
    canManagePublicMacros: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:name', 'update:visibility'],
  computed: {
    isPublicVisibilityDisabled() {
      return !this.canManagePublicMacros || this.readOnly;
    },
    publicVisibilityDescription() {
      if (this.readOnly) {
        return this.$t(
          'MACROS.EDITOR.VISIBILITY.GLOBAL.EDIT_DISABLED_DESCRIPTION'
        );
      }

      if (!this.canManagePublicMacros) {
        return this.$t(
          'MACROS.EDITOR.VISIBILITY.GLOBAL.CREATE_DISABLED_DESCRIPTION'
        );
      }

      return this.$t('MACROS.EDITOR.VISIBILITY.GLOBAL.DESCRIPTION');
    },
  },
  methods: {
    onUpdateName(value) {
      if (this.readOnly) return;

      this.$emit('update:name', value);
    },
    onUpdateVisibility(value) {
      if (this.readOnly) return;
      if (value === 'global' && !this.canManagePublicMacros) return;

      this.$emit('update:visibility', value);
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-2">
      <NextInput
        :model-value="macroName"
        :label="$t('MACROS.ADD.FORM.NAME.LABEL')"
        :placeholder="$t('MACROS.ADD.FORM.NAME.PLACEHOLDER')"
        :message="
          v$.macro.name.$error ? $t('MACROS.ADD.FORM.NAME.ERROR') : null
        "
        :message-type="v$.macro.name.$error ? 'error' : 'info'"
        :readonly="readOnly"
        @update:model-value="onUpdateName"
      />
    </div>

    <div class="flex flex-col gap-3">
      <p class="m-0 text-sm font-medium text-n-slate-12">
        {{ $t('MACROS.EDITOR.VISIBILITY.LABEL') }}
      </p>
      <RadioCard
        id="global"
        name="macro-visibility"
        :label="$t('MACROS.EDITOR.VISIBILITY.GLOBAL.LABEL')"
        :description="publicVisibilityDescription"
        :disabled-message="publicVisibilityDescription"
        :is-active="macroVisibility === 'global'"
        :disabled="isPublicVisibilityDisabled"
        @select="onUpdateVisibility('global')"
      />
      <RadioCard
        id="personal"
        name="macro-visibility"
        :label="$t('MACROS.EDITOR.VISIBILITY.PERSONAL.LABEL')"
        :description="$t('MACROS.EDITOR.VISIBILITY.PERSONAL.DESCRIPTION')"
        :is-active="macroVisibility === 'personal'"
        :disabled="readOnly"
        @select="onUpdateVisibility('personal')"
      />
    </div>

    <div class="flex items-start gap-2 p-3 rounded-lg bg-n-alpha-1">
      <Icon
        icon="i-lucide-info"
        class="flex-shrink-0 mt-0.5 size-4 text-n-slate-11"
      />
      <p class="mb-0 text-n-slate-11 text-body-para">
        {{ $t('MACROS.ORDER_INFO') }}
      </p>
    </div>
  </div>
</template>
